<template>
  <div class="blog-comment-form">
    <v-textarea
      v-model="body"
      :placeholder="parentId ? $t('blog.writeReply') : $t('blog.writeComment')"
      variant="outlined"
      :density="compact ? 'compact' : 'default'"
      :rows="compact ? 2 : 3"
      auto-grow
      hide-details
      counter="5000"
      :maxlength="5000"
      @keydown.ctrl.enter="submit"
    />

    <div class="d-flex align-center mt-2 ga-2">
      <span class="text-caption text-grey">Ctrl+Enter for at sende</span>
      <v-spacer />
      <v-btn
        :size="compact ? 'small' : 'default'"
        color="primary"
        :disabled="!body.trim()"
        :loading="submitting"
        @click="submit"
      >
        <v-icon start size="16">mdi-send</v-icon>
        {{ parentId ? $t('blog.reply') : $t('blog.comment') }}
      </v-btn>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
  postId: { type: Number, required: true },
  parentId: { type: Number, default: null },
  quotedText: { type: String, default: null },
  compact: { type: Boolean, default: false }
})

const emit = defineEmits(['submitted'])

const store = useStore()
const body = ref('')
const submitting = ref(false)

const submit = async () => {
  if (!body.value.trim() || submitting.value) return
  submitting.value = true

  try {
    // Extract @mentions from text
    const mentions = [...body.value.matchAll(/@(\w+)/g)].map(m => m[1])
    // We'd ideally resolve usernames → userIds here; for now pass as-is

    await store.dispatch('blog/addComment', {
      postId: props.postId,
      body: body.value.trim(),
      parentId: props.parentId,
      quotedText: props.quotedText,
      mentionedUserIds: null // resolve server-side if needed
    })

    body.value = ''
    emit('submitted')
  } catch (error) {
    console.error('Failed to post comment:', error)
  } finally {
    submitting.value = false
  }
}
</script>
